import replaceSpecialCharacters from 'replace-special-characters';

const replaceCharacters = (value: string): string =>
  replaceSpecialCharacters(value)
    .toLowerCase()
    .replace(/\./g, '-')
    .replace(/,/g, '-')
    .replace(/ /g, '-')
    .replace(/_/g, '-')
    .replace(/\//g, '-')
    .replace(/\\/g, '-')
    .replace(/\s/g, '-')
    .replace(/-----/g, '-')
    .replace(/----/g, '-')
    .replace(/---/g, '-')
    .replace(/--/g, '-')
    .replace(/[^a-zA-Z0-9-_]/g, '');

const prepareFriendlyUri = (value: string): string => {
  const friendlyUrl = replaceCharacters(value && value.length ? value : 'Vox');
  return encodeURI(friendlyUrl);
};

export default prepareFriendlyUri;
